import { Node_Type } from "./../../ricos-types";
import Table from "./table";
import TableCell from "./tableCell";
import TableRow from "./tableRow";
const nodeViewRenderers = {
  [Node_Type.TABLE]: Table,
  [Node_Type.TABLE_ROW]: TableRow,
  [Node_Type.TABLE_CELL]: TableCell
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
